import { colors } from './colors';

export const gradients = {
  red_vodafone: `linear-gradient(45deg, ${colors.$820000} 0%, ${colors.$e60000} 100%)`,
  skeleton_shadow: `linear-gradient(0.25turn, ${colors.$eeeeee}, ${colors.$ffffff}, ${colors.$eeeeee})`,
} as const;

type GradientsKeys = keyof typeof gradients;
export type Gradients = (typeof gradients)[GradientsKeys];
